import * as React from 'react';
import Svg, {
  G,
  Path,
  Defs,
  LinearGradient,
  Stop,
  ClipPath,
} from 'react-native-svg';

export default class CanMilk extends React.Component {
  render() {
    return (
      <Svg width={36} height={36} viewBox="0 0 36 36" fill="none">
        <G
          clipPath="url(#clip0_11255_37938)"
          fillRule="evenodd"
          clipRule="evenodd"
        >
          <Path
            d="M27.818 0H6.545v5.727h21.273V0zm-8.182 14.727l6.546-6.545H6.545L0 14.727h19.636zM36 36V17.182L28.636 9l-7.363 8.182V36H36zm-17.182 0V17.182H0V36h18.818z"
            fill="url(#paint0_linear_11255_37938)"
          />
          <Path
            d="M3.906 23.733v-.817h1.632v8.573H3.906v-7.757zm11.061 0v-.817h-1.633v8.573h1.633v-7.757zm-3.143-.817v4.9h-1.633v-4.9h1.633zm-1.633 7.757v.817h1.633V29.45h-1.633v1.224zm-1.51-7.757v4.9H7.048v-4.9H8.68zm-1.633 7.757v.817H8.68V29.45H7.048v1.224z"
            fill="#111"
          />
        </G>
        <Defs>
          <LinearGradient
            id="paint0_linear_11255_37938"
            x1={0.485217}
            y1={39.3412}
            x2={34.8932}
            y2={4.01667}
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor="#003349" />
            <Stop offset={1} stopColor="#fff" />
          </LinearGradient>
          <ClipPath id="clip0_11255_37938">
            <Path fill="#fff" d="M0 0H36V36H0z" />
          </ClipPath>
        </Defs>
      </Svg>
    );
  }
}
